import { render, staticRenderFns } from "./MemorialEdit.vue?vue&type=template&id=797fcc28&scoped=true"
import script from "./MemorialEdit.vue?vue&type=script&lang=js"
export * from "./MemorialEdit.vue?vue&type=script&lang=js"
import style0 from "./MemorialEdit.vue?vue&type=style&index=0&id=797fcc28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797fcc28",
  null
  
)

export default component.exports